module.exports = __webpack_public_path__ + "static/media/cpg_kate_meetkate.7a08224e.png";